import zod from 'zod';

export const JointProgressData = zod.object({
  jointNumber: zod.number(),
  status: zod.enum(['IDLE', 'INSTALLING', 'SUCCESS', 'FAILED', 'WAITING']),
  percentage: zod.number(),
  currentStep: zod.string(),
  logs: zod.array(zod.string()),
  errorMessage: zod.string().optional(),
});

export type JointProgressData = zod.infer<typeof JointProgressData>;

export const FirmwareInstallationStateData = zod.object({
  status: zod.enum(['IDLE', 'INSTALLING', 'SUCCESS', 'FAILED']),
  errorMessage: zod.string().optional(),
  buildId: zod.string().optional(),
  jointProgress: zod.array(JointProgressData).optional(),
  containerRunning: zod.boolean(),
});

export type FirmwareInstallationStateData = zod.infer<
  typeof FirmwareInstallationStateData
>;
